import { useMutation, useQueryClient } from '@tanstack/react-query';
import { TourFormData } from '@/features/dashboard/tourConfig/schemas/tourSchema.ts';
import { toast } from 'sonner';
import { tourDtoMapper } from '@/features/dashboard/tourConfig/types/TourDto.mapper.ts';
import { toursApiQueryKeys } from '@/features/dashboard/tours/api/toursApi.queryKeys.ts';
import TourDto, {
  TourBaseDto,
} from '@/features/dashboard/tourConfig/types/TourDto.ts';
import toursApi from '@/features/dashboard/tours/api/toursApi.ts';

export default function useCreateTour() {
  const queryClient = useQueryClient();

  const createTour = async (tour: TourFormData): Promise<TourDto> => {
    const tourDto: TourBaseDto = tourDtoMapper.fromFormToDto(tour);
    return await toursApi.createTour(tourDto);
  };

  return useMutation({
    mutationFn: createTour,
    onSuccess: () => {
      toast.success('Nowy wyjazd zapisany');
      queryClient.invalidateQueries({
        queryKey: toursApiQueryKeys.all(),
      });
    },
    onError: (error: Error) => {
      toast('Wystąpił błąd', {
        description:
          error.message || 'Wystąpił błąd podczas zapisywania danych.',
      });
    },
  });
}
